export const SUPPORTED_VIDEO_EXTENSIONS: string[] = [
  "3g2",
  "3gp",
  "avi",
  "mkv",
  "mov",
  "mpeg",
  "mp4",
  "webm",
  "wmv",
];
